import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { openDetailState, type DetailLocationState } from "./detail-navigation";

/**
 * Open a detail modal over whatever is on screen.
 *
 * Every caller goes through this rather than a bare `navigate`, because the background
 * location has to travel with the navigation: it is what closing the modal returns to, and
 * a plain push would leave the reader dropped onto a default surface having lost the
 * filtered board they opened the record from.
 */
export function useOpenDetail(): (to: string) => void {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: string) => {
      void navigate(to, { state: openDetailState(location, location.state as DetailLocationState) });
    },
    [navigate, location],
  );
}
